import { Icon } from '@/general/Icons/Icon';
import clsx from 'clsx';
import { FC, ReactNode } from 'react';

import { ButtonIcon } from '../Button/ButtonIcon';

type Props = {
  handleNextClick: () => void;
  handlePrevClick: () => void;
  controls?: {
    prev: (onClick: () => void) => ReactNode;
    next: (onClick: () => void) => ReactNode;
  };
  carouselName?: string;
  variant?: 'default' | 'recently-viewed' | 'car-match';
};

export const CarouselControls: FC<Props> = ({
  handleNextClick,
  handlePrevClick,
  controls,
  carouselName,
  variant = 'default',
}) => {
  return (
    <div
      className={clsx(
        `carouselControls pointer-events-none static hidden before:absolute before:-top-0.5 before:-left-0.5 before:block before:h-full before:w-9 before:cursor-pointer before:bg-gradient-to-r before:from-white before:to-transparent before:opacity-0 before:transition-opacity before:duration-200 before:ease-in-out before:content-[''] group-has-[.overflow-left]/carousel:before:opacity-100 after:absolute after:-top-0.5 after:-right-0.5 after:block after:h-full after:w-9 after:cursor-pointer after:bg-gradient-to-l after:from-white after:to-transparent after:opacity-0 after:transition-opacity after:duration-200 after:ease-in-out after:content-[''] group-has-[.overflow-right]/carousel:after:opacity-100 md:before:w-18 md:after:w-18 mdp:block`,
        {
          'md:left-0!': variant === 'recently-viewed',
          'before:hidden after:hidden': variant === 'car-match',
          'md:block': variant !== 'car-match',
        },
      )}
    >
      {controls ? (
        <>
          {}
          {controls.prev(handlePrevClick)}
          {}
          {controls.next(handleNextClick)}
        </>
      ) : (
        <>
          <ButtonIcon
            title="Previous slide"
            icon={<Icon name="caret-left" />}
            variant="secondary"
            size="small"
            styling="square"
            className={`carouselPrev hidden cursor-pointer opacity-0 transition-opacity duration-200 ease-in-out group-has-[.overflow-left]/carousel:opacity-100 md:pointer-events-auto md:absolute! md:top-1/2 md:left-2 md:z-10 md:-mt-5 md:inline-flex md:-translate-y-1/2 mdp:pointer-events-auto mdp:top-1/2 mdp:flex`}
            onClick={handlePrevClick}
            data-testid={carouselName ? `${carouselName}-navigation-prev` : 'carousel-prev'}
          />
          <ButtonIcon
            title="Next slide"
            icon={<Icon name="caret-right" />}
            variant="secondary"
            size="small"
            styling="square"
            className={`carouselNext hidden cursor-pointer opacity-0 transition-opacity duration-200 ease-in-out group-has-[.overflow-right]/carousel:opacity-100 md:pointer-events-auto md:absolute! md:top-1/2 md:right-2 md:z-10 md:-mt-5 md:inline-flex md:-translate-y-1/2 mdp:pointer-events-auto mdp:top-1/2 mdp:flex`}
            onClick={handleNextClick}
            data-testid={carouselName ? `${carouselName}-navigation-next` : 'carousel-next'}
          />
        </>
      )}
    </div>
  );
};
